// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import postChannelEntity from './entities/post-channel.json';
import postChannelMenu from '../pages/post-channel/menu.json';
import postChannelFullForm from '../pages/post-channel/forms/full.json';
import postChannelContextForm from '../pages/post-channel/forms/context.json';
import postChannelMiniForm from '../pages/post-channel/forms/mini.json';
import postChannelLookupForm from '../pages/post-channel/forms/lookup.json';
import postChannelTableView from '../pages/post-channel/views/table.json';
import postChannelDashboardView from '../pages/post-channel/views/dashboard.json';

/** Тип запису «Канал допису» зі сторінками пакета: меню, форми та подання з pages/post-channel/. */
export const postChannelDefinition: IRecordTypeDefinition = {
  ...postChannelEntity,
  views: assembleViewSet({
      table: postChannelTableView,
      dashboard: postChannelDashboardView,
  }),
  form: postChannelFullForm,
  forms: { full: postChannelFullForm, context: postChannelContextForm, mini: postChannelMiniForm, lookup: postChannelLookupForm },
  menu: postChannelMenu,
} as IRecordTypeDefinition;
